import { Component, Input, OnInit, OnDestroy, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ISubscription } from 'rxjs/Subscription';
import { BibliographyService } from '../../../services/bibliography.service';
import { BiblioRecord, BiblioRecordList } from '../../../models/biblio-record';
import { VocTerms } from '../../../models/voc-term';
import { BibBiblioLinkList } from '../../../models/bib-biblio-link';
import { BibFile } from '../../../models/bib-file';

@Component({
    selector: 'app-biblio-card',
    templateUrl: './biblio-card.component.html',
    styleUrls: ['./biblio-card.component.css']
})
export class BiblioCardComponent implements OnInit, OnDestroy {
    @Input() biblioRec: BiblioRecord;
    @Input() biblioRespTypesVoc: VocTerms; // vocabulary of biliographic responsability types
    @Input() isEmbedded = false;
    @Input() showTitle = true;
    private subscriptions: Array<ISubscription> = [];
    isPartOfLinks: BibBiblioLinkList = [];
    reviewOfLinks: BibBiblioLinkList = [];
    isPartOfRecords: BiblioRecordList = [];
    reviewOfRecords: BiblioRecordList = [];

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private zone: NgZone,
        private bibliographyService: BibliographyService
    ) {
    }

    ngOnInit(): void {
        if (!this.biblioRec) {
            this.subscriptions.push(
                this.route.params.subscribe(
                    params => {
                        if (params['bibId'] && params['bibId'] > 0) {
                            /* Fix needed because router navigate does not activate onInit after external request
                             * - 18/06/2018 - Angular 5.2.0 */
                            this.zone.run(() => this.router.navigate(['/bibliography', {bibId: params['bibId']}]));
                        }
                    }
                )
            );
        } else if (this.biblioRec.__linkedBiblio && this.biblioRec.__linkedBiblio.length > 0) { // load related bibliography links
            this.isPartOfLinks = this.biblioRec.__linkedBiblio.filter(bibLink => bibLink.fkidbiblio_rel_types === 5);
            this.reviewOfLinks = this.biblioRec.__linkedBiblio.filter(bibLink => bibLink.fkidbiblio_rel_types === 2);
        }
    }

    ngOnDestroy() {
        for (const subscription of this.subscriptions) {
            if (subscription) {
                subscription.unsubscribe();
            }
        }
    }

    loadIsPartOfRecords() {
        if (this.isPartOfRecords.length === 0) {
            for (const linkedBiblio of this.isPartOfLinks) {
                this.subscriptions.push(
                    this.bibliographyService.getBiblioRecord(linkedBiblio.fkidbibliography_related).subscribe(
                        response => {
                            if (response
                                && response.pkid === linkedBiblio.fkidbibliography_related
                                && !this.isPartOfRecords.find(
                                    function (bibRec) { return bibRec.pkid === linkedBiblio.fkidbibliography_related; }
                                )
                            ) {
                                this.isPartOfRecords.push(response);
                            }
                        },
                        err => console.error(err)
                    )
                );
            }
        }
    }

    loadReviewOfRecords() {
        if (this.reviewOfRecords.length === 0) {
            for (const linkedBiblio of this.reviewOfLinks) {
                this.subscriptions.push(
                    this.bibliographyService.getBiblioRecord(linkedBiblio.fkidbibliography_related).subscribe(
                        response => {
                            if (response
                                && response.pkid === linkedBiblio.fkidbibliography_related
                                && !this.reviewOfRecords.find(
                                    function (bibRec) { return bibRec.pkid === linkedBiblio.fkidbibliography_related; }
                                )
                            ) {
                                this.reviewOfRecords.push(response);
                            }
                        },
                        err => console.error(err)
                    )
                );
            }
        }
    }

    downloadFile(bibFile: BibFile): void {
        this.bibliographyService.getUploadedFile(bibFile)
            .subscribe(
                fileURL => {
                    const a = document.createElement('a');
                    document.body.appendChild(a);
                    a.setAttribute('style', 'display: none');
                    a.href = fileURL;
                    a.download = bibFile.file_name;
                    a.click();
                    URL.revokeObjectURL(fileURL);
                    a.remove();
                },
                err => {
                    console.error(err);
                    alert('Error while downloading the file!\n' + err.message);
                }
            );
    }

}



// WEBPACK FOOTER //
// ./src/app/components/ui/biblio-card/biblio-card.component.ts